/* ModalSkin.js */

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Strings from '../../translations/Translations';
import RemixSkin from '../remix/RemixSkin';

export default function ModalSkin({ open, setOpen, parentSkin, setParentSkin, callback, createMode, editMode }) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);
  const [localSkin, setLocalSkin] = useState();

  const save = useCallback(() => {
    if (localSkin && callback && setParentSkin) {
      setParentSkin(localSkin);
      callback(localSkin);
    }
  }, [localSkin, callback, setParentSkin]);
  const cancel = useCallback(() => toggle(), [toggle]);

  useEffect(() => setLocalSkin(parentSkin), [open, parentSkin]);

  return (
    <Modal isOpen={open} toggle={toggle} size='xl'>
      <ModalHeader toggle={toggle}>
        {Strings('choose_skin')}
      </ModalHeader>
      <ModalBody>
        {createMode && (
          <RemixSkin parentSkin={parentSkin} setParentSkin={setParentSkin} callback={callback} />
        )}
        {editMode && (
          <RemixSkin parentSkin={localSkin} setParentSkin={setLocalSkin} />
        )}
      </ModalBody>
      {editMode && (
        <ModalFooter className='text-right'>
          <Button color='secondary' className='mr-2' onClick={cancel}>
            {Strings('cancel')}
          </Button>
          <Button className='pb-btn-1' onClick={save}>
            {Strings('save')}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
}
